import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../web/components-v2/Select';
import { useOfficeLocationAutocompleteQuery } from '../../../queries/Aida/useOfficeLocationAutocomplete';
import { styleSheet } from '../styles';

const ALL_OFFICES = 'all';

interface IProps {
	onChange: (office: string | null) => void;
	selected: string | null;
	styles?: StyleDeclarationValue[];
}

export const OfficeSelect: React.FC<IProps> = ({ onChange, selected, styles = [] }) => {
	const { data: offices = [], isPending, isError } = useOfficeLocationAutocompleteQuery();
	const isEmpty = !isPending && !isError && offices.length === 0;
	// An account without offices has nothing to pick; a disabled dropdown would only add noise.
	if (isEmpty) {
		return null;
	}

	const isUnavailable = isPending || isError;
	const statusLabel = isPending ? 'Loading offices...' : 'Error loading offices';
	const items = [
		{ label: 'All offices', value: ALL_OFFICES },
		...offices.map(office => ({ label: `Office: ${office}`, value: office })),
	];

	return (
		<div className={css(...styles)}>
			<Select
				items={items}
				// No value while loading or failed, so the trigger shows the status instead of a choice it can't make.
				value={isUnavailable ? null : (selected ?? ALL_OFFICES)}
				disabled={isUnavailable}
				onValueChange={(next: string) => onChange(!next || next === ALL_OFFICES ? null : next)}
			>
				<SelectTrigger aria-label='Office' styles={[styleSheet.selectTrigger]}>
					<SelectValue placeholder={statusLabel} />
				</SelectTrigger>
				<SelectContent>
					{items.map(item => (
						<SelectItem key={item.value} value={item.value}>
							{item.value === ALL_OFFICES ? item.label : item.value}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
		</div>
	);
};
